import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { BlogIcon, KnowledgeBaseIcon, LinkIcon, WebsiteIcon } from 'foundations-assets';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentTypeIcon = ({
  type,
  color = 'icon-secondary-default'
}) => {
  switch (type) {
    case 'KB_ARTICLE':
      return /*#__PURE__*/_jsx(IconHolder, {
        icon: KnowledgeBaseIcon,
        color: color,
        "aria-label": I18n.text('conversations-inbox-message-history.common-message.attachmentRendering.citationSources.icon-label')
      });
    case 'HS_BLOG':
      return /*#__PURE__*/_jsx(IconHolder, {
        icon: BlogIcon,
        color: color,
        "aria-label": I18n.text('conversations-inbox-message-history.common-message.attachmentRendering.citationSources.icon-label')
      });
    case 'HS_WEB_PAGE':
      return /*#__PURE__*/_jsx(IconHolder, {
        icon: WebsiteIcon,
        color: color,
        "aria-label": I18n.text('conversations-inbox-message-history.common-message.attachmentRendering.citationSources.icon-label')
      });
    default:
      return /*#__PURE__*/_jsx(IconHolder, {
        icon: LinkIcon,
        color: color,
        "aria-label": I18n.text('conversations-inbox-message-history.common-message.attachmentRendering.citationSources.icon-label')
      });
  }
};
ContentTypeIcon.displayName = 'ContentTypeIcon';